import { OIDC_DEFAULT_SCOPES } from '@azure/msal-browser';
export const GUEST_USERNAME_REGEX = /^(.+?)(?:_([^_]*?))?\d*#EXT#@/;
/**
 * This regex extracts two things: 1) the tenant domainName from the url and 2) the rest of the url path
 * e.g: https://myaccount.microsoft.com/@domainName#/somePath/?tenantId={tenantId}?upn={upn}#hash
 * => captured group 1) domainName
 * => captured group 2) /somePath/?tenantId={tenantId}?upn={upn}#hash
 *
 * Also work on this pattern without @ and # around the tenant domainName
 * e.g: https://myaccount.microsoft.com/domainName/somePath/?tenantId={tenantId}?upn={upn}#hash
 * => captured group 1) domainName
 * => captured group 2) /somePath/?tenantId={tenantId}?upn={upn}#hash
 */
export const TENANT_DOMAIN_REGEX = /^\/@?([a-zA-Z0-9-]+\.[a-zA-Z0-9-.]+)#?(\/.*)*/;
/*
* Ignore certain domains as reserved for other purposes
*/
export const TENANT_DOMAIN_IGNORE_LIST = ['index.html'];
export const BROWSER_STORAGE = {
    ENABLE_INFO_AND_VERBOSE_LOG: 'FEATURE-AUTH_ENABLE-INFO-AND-VERBOSE-LOG',
    LATEST_ACCOUNT: 'FEATURE-AUTH_LATEST-ACCOUNT'
};
export const LOG_PREFIX = '@iamexperiences/feature-auth';
export var RequestStatus;
(function (RequestStatus) {
    RequestStatus["IDLE"] = "idle";
    RequestStatus["IN_PROGRESS"] = "inProgress";
    RequestStatus["COMPLETED"] = "completed";
    RequestStatus["FAILED"] = "failed";
})(RequestStatus || (RequestStatus = {}));
export const DEFAULT_SCOPES = [...OIDC_DEFAULT_SCOPES, 'email'];
export var AuthPrompt;
(function (AuthPrompt) {
    AuthPrompt["LOGIN"] = "login";
    AuthPrompt["SELECT_ACCOUNT"] = "select_account";
    AuthPrompt["NONE"] = "none";
    AuthPrompt["CONSENT"] = "consent";
    AuthPrompt["CREATE"] = "create";
})(AuthPrompt || (AuthPrompt = {}));
export const App_ID_Map = {
    MyApps: '2793995e-0a7d-40d7-bd35-6968ba142197',
    Iamux: '0000000c-0000-0000-c000-000000000000',
    AppManagement: 'f0ae4899-d877-4d3c-ae25-679e38eea492'
};
//# sourceMappingURL=constants.js.map